import React, { useState } from 'react';
import { Row, Col} from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { useBoolean } from '@fluentui/react-hooks';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import { useGetUsersByBookId } from '../../../../hooks/services/sBook/useOfBook';
import List from "../../../Templates/List"
import { useGetUsersByPartyId } from '../../../../hooks/services/sBook/useOfParty';
import ListPagination from '../../../Templates/List/ListPagination';
import CLabel from '../../../Common/CLabel';

const SidePanelViewUsers = (props) => {
    const { t } = useTranslation();
  
    const inputParam_IsPanelOpen = props.isPanelOpen;
    const inputParam_SetterIsPanelOpen = props.setterIsPanelOpen;
    const inputParam_BookId = props.bookId !== null && props.bookId !== undefined ? props.bookId : null;
    const inputParam_PartyId = props.partyId !== null && props.partyId !== undefined ? props.partyId : null;
    const inputParam_GetBookList = props.getBookList !== null && props.getBookList !== undefined ? props.getBookList : false;
    
    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);

    const [bookUserList, setBookUserList] = useState({fireUpdate: true, data: null, pageNumber: 1, pageSize: 1000, filters: []});
    useGetUsersByBookId(inputParam_BookId, bookUserList, setBookUserList, false, inputParam_IsPanelOpen, inputParam_GetBookList);
    useGetUsersByPartyId(inputParam_PartyId, bookUserList, setBookUserList, inputParam_IsPanelOpen, false, !inputParam_GetBookList);
    
    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen(false);
        
        setBookUserList(prevState => ({
            ...prevState,
            fireUpdate: true,
            data: null
        }));
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
    };
    
    const onClosePanel = () => {
        //No deberia ser necesario dejar en null para que obtenga nuevamente los usuarios. Esto dado que los usuarios del cliente no deberian vairar.
        //Pero si se quire, podemos descomentar esta linea para que cada vez que se seleccione "Seleccionar usuarios" en las card, se busquen los usuarios en el sistema.
        //setClientUserList(null);
        onDismissPanel();
    };

    const onRenderFooterContent = () => {
        return <div>
            <DefaultButton onClick={onClosePanel}>{t('data-lang-btn-close')}</DefaultButton>
        </div>
    }

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-sidepanel-listusers') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                <Row className="pt-3">
                    <Col>
                        <List
                            listLocalStoragePageSizeVariableName="viewUsers"
                            className="no-compact-list big-header"
                            manipulateLocalData={ true }
                            setData={setBookUserList}
                            data={bookUserList}
                            columns={[
                                {
                                    key: 'username',
                                    name: t('data-lang-lbl-username'),
                                    fieldName: 'username',
                                    minWidth: 100,
                                    onRender:(item) => {
                                        return <div>
                                            <div><CLabel labelText={t('data-lang-lbl-name')} labelValue={item.fullname} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/> ({item.username})</div>
                                            <div><CLabel labelText={t('data-lang-lbl-email')} labelValue={item.emailuser} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/></div>
                                            <div><CLabel labelText={t('data-lang-lbl-party')} labelValue={item.partyName} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/></div>
                                        </div>
                                    }
                                },
                                {
                                    key: 'roleName',
                                    name: t('data-lang-lbl-role'),
                                    fieldName: 'roleName',
                                    minWidth: 60,
                                    maxWidth: 80,
                                    onRender:(item) => {
                                        return <div>{ item.deactivate !== null ? (item.deactivate ? t('data-lang-lbl-deactivated') : item.roleName) : item.roleName }</div>
                                    }
                                },
                                {  
                                    key: 'id',
                                    name: t('data-lang-lbl-actions'),
                                    fieldName: 'username',
                                    onRender:(item, row) => {
                                        return  <div></div>
                                    }
                                }
                            ]}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col className="message-verybottom-panel-medium">
                        <ListPagination
                            listLocalStoragePageSizeVariableName="viewUsers"
                            data={ bookUserList }
                            setData={ setBookUserList } />
                    </Col>
                </Row>
            </Panel>
            <Dialog
                hidden={!isDialogVisible}
                onDismiss={onHideDialog}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: t('data-lang-msg-close-panel'),
                }}
                modalProps={{
                    isBlocking: true,
                    styles: { main: { maxWidth: 450 } },
                }}
                >
                <DialogFooter>
                    <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                    <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                </DialogFooter>
            </Dialog>
        </div>
    );
};

export default SidePanelViewUsers;